import React from "react";

// Stylesheet
import "./Footer.css";

// Assets
import footerLogo from "../../assets/footerLogo.png";

// Material UI Icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer>
      <img src={footerLogo} alt="Logo" />
      <p className="desc">
        Create, Promote and Sell NFTs{" "}|{" "}On a mission to help every creator in the world promote their NFT
      </p>
      <div className="nav footer-nav">
        <Link to="/profile">
          <h2>Profile</h2>
        </Link>
        <Link to="/createnft">
          <h2>Create</h2>
        </Link>
        <Link to="/about">
          <h2>About</h2>
        </Link>
        <a href="mailto:support@loopgem.com">
          <h2>Contact Us</h2>
        </a>
      </div>
      <div className="social-icons">
        <a href="https://www.facebook.com/loopgem/">
          <FacebookIcon />
        </a>
        <a href="https://twitter.com/LoopGem">
          <TwitterIcon />
        </a>
        <a href="https://www.instagram.com/loop_gem/">
          <InstagramIcon />
        </a>
      </div>
      <p className="copyright">
        © Copyright | LoopGem |{" "}
        <span style={{ color: "white" }}>All Rights Reserved</span>
        {" "}|{" "}
        <Link to="/privacy-policy">Privacy Policy</Link>
        {" "}|{" "}
        <Link to="/terms-and-conditions">Terms and Conditions</Link>
      </p>
    </footer>
  );
}

export default Footer;
